export default{display:"w_Du",large:"w_Dv",small:"w_Dw",weight400:"w_Dx",weight700:"w_Dy"};
